import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function CampaignWizard({
  startFrom,
  activeStep,
  hideBeforeStart,
  disablePrev,
  disableNext,
  disableSave,
  prevURL,
  nextURL,
  hideSaveAndExitOption = false,
  showNext = true,
  nextCallback,
  prevCallback,
  showRefreshPrompt,
  exitOnRefresh,
  exitURL,
  showPrev = true,
  onSaveExitClick = () => {},
}) {
  const navigate = useNavigate();

  useEffect(() => {
    if (exitOnRefresh) {
      if (exitURL) {
        window.location.href = exitURL;
        //navigate(exitURL, { replace: true });
      } else {
        window.location.href = "/";
        //navigate("/");
      }
    }
    activateStep();
    if (showRefreshPrompt) {
       window.addEventListener("beforeunload", alertUser);
    }
    return () => {
      window.removeEventListener("beforeunload", alertUser);
    };
    //nextStep();
  }, []);

  const alertUser = (event) => {
    const e = event || window.event;
    e.preventDefault();
    if (e) {
      e.returnValue = "";
    }
    return "";
  };

  function activateStep() {
    var stepper = document.getElementById("stepper1");
    var steps = stepper.getElementsByClassName("step");
    Array.from(steps).forEach((step, index) => {
      let stepNum = index + 1;
      if (stepNum === activeStep) {
        addClass(step, "editing");
      } else {
        removeClass(step, "editing");
      }
      if (stepNum < activeStep) {
        addClass(step, "done");
        if (stepNum < startFrom && hideBeforeStart) {
          addClass(step, "d-none");
        }
      } else {
        removeClass(step, "done");
      }
    });
  }
  // function nextStep() {
  //   currentStep++;
  //   activeStep++;
  //   if (activeStep > numSteps) {
  //     activeStep = 1;
  //   }
  //   var stepper = document.getElementById("stepper1");
  //   var steps = stepper.getElementsByClassName("step");

  //   Array.from(steps).forEach((step, index) => {
  //     let stepNum = index + 1;
  //     if (stepNum === activeStep) {
  //       addClass(step, "editing");
  //     } else {
  //       removeClass(step, "editing");
  //     }
  //     if (stepNum < currentStep) {
  //       addClass(step, "done");
  //       if (hideBeforeStart) {
  //         addClass(step, "d-none");
  //       }
  //     } else {
  //       removeClass(step, "done");
  //     }
  //   });
  // }

  function nextStep() {
    if (nextCallback) {
      nextCallback();
    } else {
      if (nextURL) {
        navigate(nextURL);
      }
    }
  }

  function prevStep() {
    if (prevCallback) {
      prevCallback();
    } else {
      if (prevURL) {
        navigate(prevURL);
      }
    }
  }

  function hasClass(elem, className) {
    return new RegExp(" " + className + " ").test(" " + elem.className + " ");
  }

  function addClass(elem, className) {
    if (!hasClass(elem, className)) {
      elem.className += " " + className;
    }
  }

  function removeClass(elem, className) {
    var newClass = " " + elem.className.replace(/[\t\r\n]/g, " ") + " ";
    if (hasClass(elem, className)) {
      while (newClass.indexOf(" " + className + " ") >= 0) {
        newClass = newClass.replace(" " + className + " ", " ");
      }
      elem.className = newClass.replace(/^\s+|\s+$/g, "");
    }
  }

  // function gotoPreviousPage() {
  //   if (prevURL) {
  //     navigate(prevURL);
  //   } else {
  //     navigate(-1);
  //   }
  // }

  // function gotoNextPage() {
  //   if (nextURL) {
  //     navigate(nextURL);
  //   }
  // }
  return (
    <div className="step-wizard-page">
      <div className="container">
        <div className="row step-stepper">
          <div className="col p-0 d-flex align-items-center">
            {showPrev && (<button
              disabled={disablePrev ?? false}
              onClick={prevStep}
              className="btn btn-white"
            >
              <i className="fa fa-arrow-left mr-2"></i>
              Previous
            </button>
            )}
            <div className="stepper-horizontal" id="stepper1">
              <div className="step editing">
                <div className="step-circle">
                  <span>Campaign</span>
                </div>
                <div className="step-bar-left"></div>
                <div className="step-bar-right"></div>
              </div>
              <div className="step">
                <div className="step-circle">
                  <span>Audience</span>
                </div>
                <div className="step-bar-left"></div>
                <div className="step-bar-right"></div>
              </div>
              <div className="step">
                <div className="step-circle">
                  <span>Design</span>
                </div>
                <div className="step-bar-left"></div>
                <div className="step-bar-right"></div>
              </div>
              <div className="step">
                <div className="step-circle">
                  <span>Summary</span>
                </div>
                <div className="step-bar-left"></div>
                <div className="step-bar-right"></div>
              </div>
              <div className="step">
                <div className="step-circle">
                  <span>Send</span>
                </div>

                <div className="step-bar-left"></div>
                <div className="step-bar-right"></div>
              </div>
            </div>
            {!hideSaveAndExitOption ? (
              <button
                disabled={disableSave ?? false}
                className="btn btn-blue ml-4"
                onClick={onSaveExitClick}
              >
                Save and Exit
              </button>
            ) : null}
            {showNext && (
              <button
                disabled={disableNext ?? false}
                onClick={nextStep}
                className="btn btn-blue"
              >
                Next
                <i className="fa fa-arrow-right ml-2"></i>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
